


















































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '../models/commonVue';

import { BusEvent } from '../models/bus';
import FieldImage from '../components/FieldImage.vue';
import FieldInternational from '../components/FieldInternational.vue';
import DropDownEntity from '../components/DropDownEntity.vue';
import DropDownText from '../components/DropDownText.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import FieldVideos from '@/components/FieldVideos.vue';
import FieldInterfaceElements from '@/components/FieldInterfaceElements.vue';
import Program from '@/api/program';
import Skill from '@/api/skill';
import ApiList from '@/api/list';
import { isEmpty, isNil } from 'lodash';
import School from '@/api/school';
import { MediaFileField } from '@/models/fields';
import Media from '@/api/media';

@Component({
  components: {
    'field-interface-elements': FieldInterfaceElements,
    'drop-down-entity': DropDownEntity,
    'drop-down-text': DropDownText,
    'field-international': FieldInternational,
    'field-image': FieldImage,
    'edit-icon': EditIcon,
    'field-videos': FieldVideos
  }
})
export default class EditProgram extends CommonVue {
  @Prop({ type: Number }) public id?: number;
  public skillOptions: ApiList<Skill> = null;
  public schoolOptions: ApiList<School> = null;

  public program: Program = null;
  public programName: string = '';

  public async beforeMount() {
    await this.load();
  }

  @Watch('id')
  public async load() {
    this.busy = true;
    this.error = false;

    await this.loadSkillList();
    await this.loadProgram();

    this.updateName();
    this.busy = false;
  }

  public async loadProgram(): Promise<void> {
    if (!this.id) {
      this.program = new Program();

      //Temporarily hardcode by Elsa id
      this.program.school = 1;
    } else {
      this.program = await Program.get(this.id);
    }
  }

  public async loadSkillList(): Promise<void> {
    this.skillOptions = await Skill.listAll();
  }

  public updateName() {
    let name = this.program.name.getDefaultValue();
    if (!name) {
      name = '';
    }
    this.programName = name;
  }

  public checkMandatoryFields() {
    const defaultName = this.program.name.getDefaultValue();
    if (isEmpty(defaultName)) {
      throw Error('Please insert an English name for your program.');
    }

    if (
      isNil(this.program.program_skill_1) ||
      isNil(this.program.program_skill_2)
    ) {
      throw Error('Please select program skills.');
    }
  }

  public async saveMediaFile(
    field: any,
    fieldName: string
  ): Promise<number | null | undefined> {
    if (!this.program || !this.program.id) {
      return null;
    }
    const mediaFileField = (field as any) as MediaFileField;
    if (mediaFileField.hasNewMedia()) {
      return await mediaFileField.upload(
        this.MODULE_SLUG,
        this.program.id,
        fieldName
      );
    } else if (!mediaFileField.hasMedia()) {
      return undefined;
    } else {
      return null;
    }
  }

  public async saveMediaFiles(): Promise<void> {
    if (!this.program || !this.program.id) {
      throw Error('Module has not been created yet.');
    }

    this.imagesToDelete.forEach(async (id) => await Media.deleteImage(id));
    this.imagesToDelete = [];

    const bg_image = await this.saveMediaFile(this.$refs.bg_image, 'bg_image');
    if (bg_image !== null) {
      this.program.bg_image = bg_image;
    }
  }

  public async saveClicked(): Promise<void> {
    try {
      this.busy = true;
      this.checkMandatoryFields();

      if (isNil(this.id)) {
        await this.program.save();
        await this.saveMediaFiles();
        await this.program.update();
      } else {
        await this.saveMediaFiles();
        await this.program.update();
      }
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not save module', e);
    } finally {
      this.busy = false;
      this.$router.push(`/${this.PROGRAM_SLUG}`);
    }
  }

  public async deleteClicked(): Promise<void> {}
}
